/* Copyright (c) 2017 Backpack Health LLC */
import { Icons } from '../bphComponents/bundle';

enum HealthEntryCategoryNames {
  allergy = 'allergy',
  condition = 'condition',
  medication = 'medication',
  otherTreatment = 'other_treatment',
  procedure = 'procedure',
  vaccination = 'vaccination',
  lab = 'lab',
  measurement = 'measurement',
  geneticResult = 'genetic_result',
  geneVariantResult = 'gene_variant_result',
  missing = 'missing',
}

export enum AllergySubType {
  medication = 'medication',
  food = 'food',
  other = 'other',
}

export function isMultiOccurencesCategory(category: HealthEntryCategoryNames): boolean {
  return category === HealthEntryCategoryNames.lab ||
    category === HealthEntryCategoryNames.measurement ||
    category === HealthEntryCategoryNames.geneticResult;
}

export function isGeneticResultCategory(category: HealthEntryCategoryNames): boolean {
  return category === HealthEntryCategoryNames.geneticResult;
}





const HealthEntryDataLookup = {
  [HealthEntryCategoryNames.condition]: {
    Icon: Icons.IconCondition,
    titlePhrase: {
      id: 'list.healthEntry.conditions.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.medication]: {
    Icon: Icons.IconMedication,
    titlePhrase: {
      id: 'list.healthEntry.medications.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.vaccination]: {
    Icon: Icons.IconVaccinations,
    titlePhrase: {
      id: 'list.healthEntry.vaccinations.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.allergy]: {
    Icon: Icons.IconAllergies,
    titlePhrase: {
      id: 'list.healthEntry.allergy.name',
      values: {
        digit1: 1,
      },
    },
  },

  [HealthEntryCategoryNames.otherTreatment]: {
    Icon: Icons.IconTreatments,
    titlePhrase: {
      id: 'list.healthEntry.treatments.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.procedure]: {
    Icon: Icons.IconProcedures,
    titlePhrase: {
      id: 'list.healthEntry.procedures.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.measurement]: {
    Icon: Icons.IconMeasurements,
    titlePhrase: {
      id: 'list.healthEntry.measurements.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.lab]: {
    Icon: Icons.IconLabs,
    titlePhrase: {
      id: 'list.healthEntry.lab.name',
      values: {
        digit1: 1,
      },
    },
  },
  [HealthEntryCategoryNames.geneticResult]: {
    Icon: Icons.IconLabs,
    titlePhrase: {
      id: 'list.healthEntry.genes.name',
      values: {
        digit1: 1,
      },
    },
  },
};

const AllergyDataLookup = {
  [AllergySubType.medication]: {
    Icon: Icons.IconMedicationAllergy,
    titlePhrase: {
      id: 'list.healthEntry.allergiesMedication.name',
      values: {
        digit1: 1,
      },
    },
  },
  [AllergySubType.food]: {
    Icon: Icons.IconFoodAllergy,
    titlePhrase: {
      id: 'list.healthEntry.allergiesFood.name',
      values: {
        digit1: 1,
      },
    },
  },
  [AllergySubType.other]: {
    Icon: Icons.IconAllergies,
    titlePhrase: {
      id: 'list.healthEntry.allergiesOther.name',
      values: {
        digit1: 1,
      },
    },
  },
}

export function getHealthEntryCategoryData(healthEntry) {
  const category = healthEntry.category;
  const subCategoryName = healthEntry[category].type || null;

  switch (category) {
    case HealthEntryCategoryNames.allergy:
      if (AllergyDataLookup[subCategoryName]) {
        return AllergyDataLookup[subCategoryName];
      } else {
        return AllergyDataLookup[AllergySubType.other];
      }
    default:
      return HealthEntryDataLookup[category];
  }
}

export default HealthEntryCategoryNames;
